module.exports = __webpack_public_path__ + "static/media/briscola.b6e2e22f.jpg";